import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import styles from './styles';
import { adminSetTmsMailInfoExport, SaveApiResMessage } from '@/actions';

export default ({ notify, selectedCompany, DATA }) => {
  const cls = styles();

  const [state, setState] = useState({
    tms_mail_subject_export: '',
    tms_mail_subject_contain_export: null,
    tms_mail_address_export: '',
    plain_mail: false,
    mail_pattern: '',
  });

  const handleSendForm = () => {
    let apiData = {
      tms_mail_subject_export: state.tms_mail_subject_export,
      tms_mail_address_export: state.tms_mail_address_export,
      // _method: 'patch',
    };
    if (state.tms_mail_subject_contain_export) {
      apiData.tms_mail_subject_contain_export =
        state.tms_mail_subject_contain_export === 'Contain' ? 1 : 0;
    }
    if (state.plain_mail) {
      apiData.plain_mail = state.plain_mail;
    }
    if (state.mail_pattern) {
      apiData.mail_pattern = state.mail_pattern;
    }
    adminSetTmsMailInfoExport(apiData, selectedCompany.value).then((data) => {
      // notify('Successfully Saved');
      SaveApiResMessage({
        title: data?.data?.messageHeader,
        message: 'Successfully Saved',
        mode: 'success',
      });
    });
  };

  const handleChangeInput = (name, value) => {
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    setState({
      tms_mail_subject_export: DATA.tms_mail_subject_export,
      tms_mail_address_export: DATA.tms_mail_address_export,
      plain_mail: DATA.plain_mail,
      mail_pattern: DATA.mail_pattern,
      tms_mail_subject_contain_export:
        DATA.tms_mail_subject_contain_export === 0 ||
        DATA.tms_mail_subject_contain_export === 1
          ? DATA.tms_mail_subject_contain_export === 1
            ? 'Contain'
            : 'Exact'
          : null,
    });
  }, [DATA]);

  return (
    <div>
      <div className={cls.inputContainer}>
        <span>From:</span>
        <TextField
          type="text"
          placeholder="From"
          className={cls.input}
          InputProps={{ disableUnderline: true }}
          inputProps={{ min: 0 }}
          value={state.tms_mail_address_export}
          onChange={(e) =>
            handleChangeInput('tms_mail_address_export', e.target.value)
          }
        />
      </div>
      <div className={cls.inputContainer}>
        <span>Subject:</span>
        <TextField
          type="text"
          placeholder="Subject"
          className={cls.input}
          InputProps={{ disableUnderline: true }}
          inputProps={{ min: 0 }}
          value={state.tms_mail_subject_export}
          onChange={(e) =>
            handleChangeInput('tms_mail_subject_export', e.target.value)
          }
        />
      </div>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={state.tms_mail_subject_contain_export}
          className={cls.mailCheck}
          onChange={(e) => {
            setState((prev) => {
              return {
                ...prev,
                tms_mail_subject_contain_export: e.target.value,
              };
            });
          }}>
          <FormControlLabel
            value={'Contain'}
            control={<Radio />}
            label={'Contain'}
          />
          <FormControlLabel
            value={'Exact'}
            control={<Radio />}
            label={'Exact'}
          />
        </RadioGroup>
      </FormControl>
      <div>
        {/* <div className={cls.optionContainer}>
          <span className={cls.mondayCheck}>Monday Emails:</span>
          <FormControlLabel
            style={{ margin: 0 }}
            className={`${
              state.plain_mail ? cls.enabledContainer : cls.disabledContainer
            }`}
            control={
              <Checkbox
                checked={state.plain_mail ? true : false}
                onChange={(e) =>
                  setState((prev) => {
                    return {
                      ...prev,
                      plain_mail: e.target.checked,
                    };
                  })
                }
              />
            }
          />
        </div> */}
      </div>
      <div className={cls.btnContainer}>
        <Button onClick={() => handleSendForm()}>Save</Button>
      </div>
    </div>
  );
};
